// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ExploitIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ExploitIcon" ref={forwardedRef} {...props}>
      <path d="m15.898 1.5-1.91 1.612.966 1.146 1.91-1.612z" />
      <path d="M12.407 6.57a1.25 1.25 0 0 0-1.199.292l-.8.752a5.5 5.5 0 1 1-1.283-.853l1.055-.99a2.75 2.75 0 0 1 2.637-.643l1.9.54-.41 1.443zm-1.792 4.118a4 4 0 1 0-7.727 2.07 4 4 0 0 0 7.727-2.07" />
      <path d="m15.988 7.714 1.61 1.91-1.146.967-1.611-1.91z" />
      <path d="m18.737 5.095-2.5.017-.002 1.505 2.5-.017z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ExploitIcon = /* @__PURE__ */ Object.assign(ExploitIconComponent, {
  displayName: 'ExploitIcon',
});
